export const I18N_PATH = 'new_team_drawer.add_team_success_modal';
export const I18N_BUTTON_PATH = `${I18N_PATH}.buttons`;
